/**
 * i18n keys for the payment-link feature, shared by the line actions, the pills and the audit
 * trail. Follows the {@link DESK_PAYMENT_KEY_PREFIX} precedent: every wording of one feature
 * lives in one place, under one namespace.
 */
export const PAYMENT_LINK_KEY_PREFIX = 'doctor-dashboard.billing.paymentLink';

/** The copy-link action, worded once for the surfaces that offer it. */
export const PAYMENT_LINK_COPY_ACTION_KEY =
  `${PAYMENT_LINK_KEY_PREFIX}.action.copy` as const;

/**
 * Why a payment made on a link could not be booked — STRIPE_LINK_PAYMENT_UNBOOKED's
 * `details.reason`. Takes the raw token, as the desk-payment reason builders do, so a reason
 * added backend-side degrades to its own name instead of breaking the build. Reached from
 * {@link billingLineEventReasonLabelKey}.
 */
export const paymentLinkUnbookedReasonLabelKey = (reason: string) =>
  `${PAYMENT_LINK_KEY_PREFIX}.unbookedReason.${reason}` as const;
